import { render } from "./Form.vue?vue&type=template&id=6d248932&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=6d248932&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6d248932"

export default script